import { Action } from 'redux';
import { FormField } from 'sos-common/js/commonTypes/formField.types';
import { PayloadAction } from 'sos-common/js/commonTypes/action.types';
import { FieldStates } from 'sos-common/js/commonTypes/formField.types';

export const SET_FORM_VALUE = 'SET_FORM_VALUE';

type fieldOrFiledArray = FormField<any> | FormField<any>[];
export type setFormValueAction = PayloadAction<typeof SET_FORM_VALUE, fieldOrFiledArray>;

export const SEND_FORM_ORDER = 'SEND_FORM_ORDER';
export type sendFormOrderAction = Action<typeof SEND_FORM_ORDER>;

export type formModelActions = setFormValueAction | sendFormOrderAction;

export const FLIP_IS_SENDING_FLAG = 'FLIP_IS_SENDING_FLAG';
export type flipIsSendingFlagAction = Action<typeof FLIP_IS_SENDING_FLAG>;

export const SET_TOUCHED_MAP = 'SET_TOUCHED_MAP';
export type setTouchedMapAction = PayloadAction<typeof SET_TOUCHED_MAP, Map<any, any>>;
